// Dashboard utility functions

/**
 * Generate years array for dropdown (current year and past 5 years)
 */
export const generateYears = (): string[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 6 }, (_, i) => (currentYear - i).toString());
};

/**
 * Get months array for dropdown
 */
export const getMonths = (): string[] => {
  return [
    'All Months',
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
};

/**
 * Calculate percentage
 */
export const calculatePercentage = (value: number, total: number): number => {
  if (total === 0) return 0;
  return Number(((value / total) * 100).toFixed(1));
};

